import FormHeader from '../../../../../../components/Layout/FormHeader';
import { DateInput } from '../../../../../../components/Common';
import { addYears } from 'date-fns';
import styled from 'styled-components';
import { useTenant } from '../../../../../../hooks/useTenant';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from '../../../../../../reducers';
import { setBirthDate } from '../../../../../../actions/order';
import { Controller, useFormContext } from 'react-hook-form';
import { RentDataDto } from './dto/RentDataDto';
import { Header, Input } from 'src/components/ui';
import { __ } from 'src/helpers/i18n';

interface Props {
  disabled?: boolean;
}

const DateInputContainer = styled('div')({
  marginBottom: 20,
});

const TenantDetailsForm = ({ disabled }: Props) => {
  const { tenant } = useTenant();
  const dispatch = useDispatch();
  const { formData } = useSelector((state: ApplicationState) => state.order);
  const {
    register,
    control,
    formState: { errors },
  } = useFormContext<RentDataDto>();

  return (
    <>
      <Header variant="h2">{__('rent.rentier_data')}</Header>
      <Input
        label="rent.first_name"
        placeholder="rent.first_name_placeholder"
        {...register('firstName')}
        error={errors.firstName?.message}
        disabled
      />
      <Input
        label="rent.last_name"
        placeholder="rent.last_name_placeholder"
        {...register('lastName')}
        error={errors.lastName?.message}
        disabled
      />
      {tenant?.birthDateNecessary ? (
        <Controller
          name="birthDate"
          control={control}
          render={({ field }) => (
            <DateInput
              {...field}
              inline={false}
              name="birthDate"
              error={errors.birthDate?.message}
              label="rent.birth_date"
              onChange={([selected]) => {
                field.onChange(selected);
              }}
            />
          )}
        />
      ) : null}
      <Input
        label="rent.street"
        {...register('street')}
        error={errors.street?.message}
        disabled={disabled}
        placeholder="rent.street_placeholder"
      />
      <Input
        {...register('city')}
        error={errors.city?.message}
        label="rent.city"
        disabled={disabled}
        placeholder="rent.city_placeholder"
      />
      <Input
        {...register('postCode')}
        error={errors.postCode?.message}
        label="rent.post_code"
        disabled={disabled}
        placeholder="rent.post_code_placeholder"
      />

      <Input
        {...register('mailToSendInvoice')}
        error={errors.mailToSendInvoice?.message}
        disabled
        label="rent.email"
        placeholder="rent.email_placeholder"
      />
      <Input
        label="application.phone"
        {...register('phone')}
        error={errors.phone?.message}
        disabled
        placeholder="rent.phone_placeholder"
      />
    </>
  );
};

export default TenantDetailsForm;
